<div
    class="overlay-loading d-flex flex-column align-items-center justify-content-center"
    *ngIf="overlay"
    [class.overlay-loading--fixed]="fixed"
>
    <!-- <template [ngTemplateOutlet]="loadingRef"></template>
    <h6 *ngIf="label" class="mb-0 mt-3 text-center" [innerHTML]="label"></h6> -->
    <ng-container [ngTemplateOutlet]="loadingRef"></ng-container>
    <h6 *ngIf="label" class="mb-0 mt-3 text-center" [innerHTML]="label"></h6>
</div>

<ng-container *ngIf="!overlay">
    <!-- <template [ngTemplateOutlet]="loadingRef"></template>
    <span class="ml-2" *ngIf="label">{{ label }}</span> -->
    <div class="d-flex flex-column align-items-center justify-content-center">
        <ng-container [ngTemplateOutlet]="loadingRef"></ng-container>
        <h6 *ngIf="label" class="mb-0 mt-3 text-center">{{ label }}</h6>
    </div>
</ng-container>

<ng-template #loadingRef>
    <span
        *ngIf="!image?.length"
        class="spinner-{{ type }}"
        [ngClass]="color"
        [class.spinner-border-sm]="type === 'border' && size === 'sm'"
        [class.spinner-grow-sm]="type === 'grow' && size === 'sm'"
    >
    </span>
    <img
        *ngIf="image?.length"
        [ngClass]="[useFullSize ? 'fullSize' : 'responsive', animateImage ? 'img-animate' : '']"
        [class.spinner-border-sm]="type === 'border' && size === 'sm'"
        [class.spinner-grow-sm]="type === 'grow' && size === 'sm'"
        src="{{ assetsUrl }}{{ mfsPath }}/{{ image }}"
        [alt]="'Loading...'"
    />
</ng-template>
